import badgeAsDownloadon from '../../../assets/images/onboarding/badge_as_downloadon.svg'
import badgeAsLogo from '../../../assets/images/onboarding/badge_as_logo.svg'
import badgeAsText from '../../../assets/images/onboarding/badge_as_text.svg'
import badgeGpGetit from '../../../assets/images/onboarding/badge_gp_getit.svg'
import badgeGpLogo from '../../../assets/images/onboarding/badge_gp_logo.svg'
import badgeGpText from '../../../assets/images/onboarding/badge_gp_text.svg'

export function AppStoreBadge() {
  return (
    <a
      href="https://apps.apple.com/se/app/w-identity/id6758667517"
      target="_blank"
      rel="noopener noreferrer"
      style={{textDecoration: 'none'}}
      data-testid="appStoreBadge">
      <div
        style={{
          position: 'relative',
          width: 120,
          height: 40,
          backgroundColor: '#000',
          border: '1px solid #a6a6a6',
          borderRadius: 7,
          flexShrink: 0,
        }}>
        <img
          src={badgeAsLogo}
          alt=""
          style={{
            position: 'absolute',
            left: 8.97,
            top: '21.8%',
            bottom: '23.76%',
            width: 17.717,
            height: 21.776,
          }}
        />
        <img
          src={badgeAsDownloadon}
          alt=""
          style={{
            position: 'absolute',
            left: 34.65,
            top: '21.04%',
            bottom: '63.03%',
            width: 69.151,
            height: 6.37,
          }}
        />
        <img
          src={badgeAsText}
          alt="Download on the App Store"
          style={{
            position: 'absolute',
            left: 33.45,
            bottom: '16.26%',
            top: '44.43%',
            width: 75.076,
            height: 15.72,
          }}
        />
      </div>
    </a>
  )
}

export function GooglePlayBadge() {
  return (
    <a
      href="https://play.google.com/store/apps/details?id=com.widentity.app"
      target="_blank"
      rel="noopener noreferrer"
      style={{textDecoration: 'none'}}
      data-testid="googlePlayBadge">
      <div
        style={{
          position: 'relative',
          width: 135,
          height: 40,
          backgroundColor: '#000',
          border: '1px solid #a6a6a6',
          borderRadius: 5,
          overflow: 'hidden',
          flexShrink: 0,
        }}>
        <img
          src={badgeGpLogo}
          alt=""
          style={{
            position: 'absolute',
            left: 8.97,
            top: '17.85%',
            bottom: '17.85%',
            width: 23.09,
            height: 25.07,
          }}
        />
        <img
          src={badgeGpGetit}
          alt=""
          style={{
            position: 'absolute',
            left: 40.35,
            top: '17.16%',
            bottom: '67.17%',
            width: 38.848,
            height: 6.269,
          }}
        />
        <img
          src={badgeGpText}
          alt="Get it on Google Play"
          style={{
            position: 'absolute',
            left: 40.04,
            bottom: '14.81%',
            top: '42.62%',
            width: 84.776,
            height: 17.03,
          }}
        />
      </div>
    </a>
  )
}

export function AppStoreBadgesRow() {
  return (
    <div
      style={{
        display: 'flex',
        gap: 8,
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px 40px',
      }}>
      <AppStoreBadge />
      <GooglePlayBadge />
    </div>
  )
}
